import React from 'react'
import * as PropTypes from 'prop-types'
import gql from 'graphql-tag'
import WebPage from './webpage'
import { client as apolloClient } from '../apollo'

export class PreviewPageComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isPageReadyForDisplay: false,
      data: {},
      pageMessage: 'Preview loading'
    }
  }

  componentDidMount = () => {
    const previewID = this.getPreviewID()
    const { pageType } = this.props
    const client = apolloClient()

    return client.query({
      variables: {
        id: previewID
      },
      query: this.getQuery(pageType.toLowerCase()),
      fetchPolicy: 'no-cache'
    })
      .then(this.setPageData)
      .catch((err) => {
        this.setState({
          pageMessage: 'Preview is unavailable'
        })
        throw err
      })
  }

  getQuery (pageType) {
    if (pageType === 'page') {
      return pageQuery
    }
    if (pageType === 'landingpage') {
      return landingpageQuery
    }
  }

  setPageData = ({ data }) => {
    const pageData = {
      site: {
        siteMetadata: {
          productionSiteUrl: process.env.GATSBY_SITE_URL
        }
      },
      scms: {
        page: data.previewPage,
        hoursOfOperations: data.hoursOfOperations
      }
    }

    if (!pageData.scms.page) {
      this.setState({
        pageMessage: 'Preview has expired'
      })

      return
    }

    const today = new Date().toISOString()
    pageData.scms.page = Object.assign({}, pageData.scms.page, {
      createdAt: today,
      updatedAt: today
    })

    this.setState({
      data: pageData,
      isPageReadyForDisplay: true
    })
  }

  // URLSearchParams doesn't work in IE, but I don't think anyone using this will be using IE.
  // At least they better not if they want to preview a page or not be publicly shamed
  getPreviewID = () => {
    // eslint-disable-next-line react/prop-types
    const url = new URLSearchParams(this.props.location.search)

    return url.get('previewid') || url.get('previewId')
  }

  render () {
    const { isPageReadyForDisplay, data, pageMessage } = this.state

    return (
      isPageReadyForDisplay
        ? (
          <WebPage page={data.scms.page} operatingHours={data.scms.hoursOfOperations} site={data.site} isPreview={true}/>
        ) : (
          <div>
            {pageMessage}
          </div>
        )
    )
  }
}

const pageQuery = gql`
  query preview($id: ID!) {
    previewPage(id: $id) {
      title
      type
      pageUrl
      phoneNumber
      header {
        component
        links
        showZipSearchMobile
        showZipSearchDesktop
      }
      footer {
        component
        links
      }
      modules
      metadataTitle
      metadataKeywords
      metadataDescription
      metadataTwTitle
      metadataTwUrl
      metadataTwCard
      metadataTwSite
      metadataTwDescription
      metadataTwImage
      metadataOgTitle
      metadataOgUrl
      metadataOgType
      metadataOgDescription
      metadataOgImage
      metadataCanonical
      metadataRobots
      metadataPublishedDate
      metadataModifiedDate
      showMobileHeaderCta
      structuredData
    }
  }
`

const landingpageQuery = gql`
  query preview($id: ID!) {
    previewPage(id: $id) {
      title
      type
      pageUrl
      phoneNumber
      header {
        component
        links
        showZipSearchMobile
        showZipSearchDesktop
      }
      footer {
        component
        links
      }
      modules
      metadataTitle
      metadataKeywords
      metadataDescription
      metadataTwTitle
      metadataTwUrl
      metadataTwCard
      metadataTwSite
      metadataTwDescription
      metadataTwImage
      metadataOgTitle
      metadataOgUrl
      metadataOgType
      metadataOgDescription
      metadataOgImage
      metadataCanonical
      metadataRobots
      metadataPublishedDate
      metadataModifiedDate
      showMobileHeaderCta
      structuredData
    }
  }
`

PreviewPageComponent.propTypes = {
  client: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
  pageType: PropTypes.string.isRequired
}
